/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import { IMoeV2HeaderBannerViewProps } from './moe-v2-header-banner';

export default (props: IMoeV2HeaderBannerViewProps) => {
    const { config } = props;
    const {
        title,
        backgroundColor,
        titleSize = 'h2',
        backgroundWidth = '100',
        titlePaddingLeft = '0.5rem',
        additionalText,
        bannerImage,
        moduleHeight,
        titleColor
    } = config;

    const containerStyles: React.CSSProperties = {
        overflow: 'hidden',
        height: moduleHeight
    };

    const textContainerStyles: React.CSSProperties = {
        paddingLeft: `${titlePaddingLeft}`,
        backgroundColor: backgroundColor || 'transparent',
        width: `${backgroundWidth}%`
    };

    const createTitleElement = () => {
        if (!title) {
            return null;
        }
        const TitleTag = titleSize as keyof JSX.IntrinsicElements;
        return (
            <TitleTag className='moe-v2-header-banner__title' style={{ margin: 0, color: titleColor }}>
                {title}
            </TitleTag>
        );
    };

    const renderAdditionalText = () => {
        if (!additionalText) {
            return null;
        }
        return (
            <div
                className='moe-v2-header-banner__additional-text'
                dangerouslySetInnerHTML={{ __html: ((props.config.additionalText as unknown) as string) || '' }}
            />
        );
    };

    return (
        <div className='moe-v2-module-container moe-v2-header-banner' style={containerStyles} data-content-width={backgroundWidth}>
            <div className='moe-v2-header-banner__content' style={textContainerStyles}>
                {createTitleElement()}
                {renderAdditionalText()}
            </div>
            {bannerImage?.src && (
                <div className='moe-v2-header-banner__image-container'>
                    <img src={bannerImage.src} alt={bannerImage.altText || title || 'Banner'} className='moe-v2-header-banner__image' />
                </div>
            )}
        </div>
    );
};
